<template>
  <div class="container-filho">
    <div>
      <template v-if="!emprestimoSolicitado">
        <template v-if="simulador">
          <Titulo title="Simulador de<br>Empréstimos" />
          <div style="margin-top: 30px">
            <div v-if="pre_aprovado && pre_aprovado > 0" class="div_msg_emprestimo__se">
              - Valor líquido pré-aprovado: R$ {{ str_pre_aprovado }}.
            </div>
            <div v-if="saldo_devedor && saldo_devedor > 0" class="div_msg_emprestimo__se">
              - Saldo devedor atual: R$ {{ str_saldo_devedor }}.
            </div>
            <div v-if="maximo && maximo > 0" class="div_msg_emprestimo__se">
              - Valor máximo permitido: R$ {{ str_maximo }}.
            </div>
            <div v-if="taxa_mensal && taxa_mensal > 0" class="div_msg_emprestimo__se">
              - Taxa de juros : {{ str_taxa_mensal }}% ao mês.
            </div>

            <p class="p_espaco_35__se"></p>
            <p class="p_label__se">Valor que deseja receber em conta-corrente:</p>
            <div style="margin-left: 20px; margin-right: 20px; display: flex">
              <money
                class="input_principal__se"
                v-model="principal"
                inputmode="numeric"
                :masked="false"
                v-bind="money"
                maxlength="15"
                :disabled="pre_aprovado < minimo"
              ></money>
            </div>
            <p class="p_mensagem_invalido__se" v-show="!valido_maximo">
              Valor excede o máximo permitido!
            </p>
            <p class="p_mensagem_invalido__se" v-show="!valido_minimo">
              Valor menor que o mínimo permitido!
            </p>
            <p class="p_espaco_30__se"></p>
            <p class="p_label__se">Parcelamento</p>
            <p class="p_slider__se">
              <VueSlider
                v-model="quantidade"
                ref="slider"
                v-bind="sliderOptions"
                :tooltip-formatter="formatter1"
              />
            </p>
            <p class="p_valor_simulado__se">{{ quantidade }} x R$ {{ parcela }}</p>
            <p class="p_label__se">* Valor calculado para primeira parcela</p>
            <p class="p_espaco_30__se"></p>
            <button
              @click="confirmarBcoAgCc()"
              :disabled="pre_aprovado < minimo || !valido_maximo || !valido_minimo"
            >
              Continuar
            </button>
          </div>
          <Disclaimer :tipo="disclaimerTipo" />
        </template>
        <template v-if="!simulador">
          <Contratacao
            v-bind:dados="contratacao"
            @fechar-contratacao="fecharContratacao(true)"
            @recarregar-dados="consultaDadosContratados()"
          />
        </template>
      </template>
      <template v-else>
        <ContratacaoAberta
          v-bind:dados="dadosEmprestimoSolicitado"
          @recarregar-dados="consultaDadosContratados()"
        />
      </template>
    </div>

    <Modal v-if="modais.bloqueioIdade">
      <template v-slot:body>
        <div
          class="mdl-card-container div-container"
          style="width: 90%; margin-top: 30px"
        >
          <p class="text_modal">Puxa vida!</p>
          <p class="text_modal2">
            <br />Infelizmente não é possível a contratação de empréstimos para
            participantes com idade inferior a 18 anos.
          </p>
        </div>
        <div class="mf__div-btn">
          <button class="mf__btn--voltar" @click="voltar()">Voltar</button>
        </div>
      </template>
    </Modal>

    <Modal v-if="modais.bcAgCc" style="padding: 0px">
      <template v-slot:body>
        <div class="container-filho">
          <div style="margin: 20px 0px">
            <span class="close" @click="closeModal()">&times;</span>
            <p class="text_modal">Dados Bancários!</p>
          </div>
          <p class="text_modal2">
            <br />Confirme seus dados bancários para crédito do empréstimo.
          </p>
          <!-- inputs -->
          <div style="margin: 20px 0px">
            <div class="itemCadastro">
              <BancoSelect
                @input="bancoSelected"
                :value="dados_bancarios.banco"
                :error="!valid_dados_bancarios.banco"
              />
            </div>
            <p
              v-if="dados_bancarios.banco === '-' && !valid_dados_bancarios.banco"
              class="error-valid"
            >
              Banco obrigatório!
            </p>
            <div class="itemCadastro">
              <span class="input-label" style="font-size: 12px">Agência:</span>
              <input
                autocomplete="off"
                v-mask="'######'"
                ref="agencia"
                type="text"
                v-model="dados_bancarios.agencia"
              />
            </div>
            <p
              v-if="dados_bancarios.agencia === '' && !valid_dados_bancarios.agencia"
              class="error-valid"
            >
              Agência obrigatória!
            </p>
            <div class="itemCadastro">
              <span class="input-label" style="font-size: 12px"
                >Conta Corrente com DV:</span
              >
              <the-mask
                autocomplete="off"
                :mask="['####-#', '#####-#', '######-#', '#######-#']"
                ref="contacorrente"
                type="text"
                v-model="dados_bancarios.conta"
              />
            </div>
            <p
              v-if="dados_bancarios.conta === '' && !valid_dados_bancarios.conta"
              class="error-valid"
            >
              Conta Corrente obrigatória!
            </p>
          </div>
          <button class="mf__btn--confirmar" @click="validarBcoAgCc()">Continuar</button>
          <button class="mf__btn--voltar mf__btn--group" @click="closeModal()">
            Voltar
          </button>
        </div>
      </template>
    </Modal>

    <Modal
      v-if="modais.bloqueioEmprestimoRecente"
      :modalCustom="'padding-top: 0px !important;'"
      :modalContentCustom="'padding-top: 0px !important;'"
    >
      <template v-slot:body>
        <div
          class="mdl-card-container div-container"
          style="width: 90%; margin-top: 30px"
        >
          <p class="text_modal">Puxa vida!</p>
          <p class="text_modal2">
            <br />Infelizmente não é possível a contratação de empréstimos para
            participantes com concessões recentes.
          </p>
        </div>
        <div class="mf__div-btn">
          <button class="mf__btn--voltar" @click="voltar()">Voltar</button>
        </div>
      </template>
    </Modal>

    <Modal
      v-if="modais.bloqueioSaldoInsuficiente"
      :modalCustom="'padding-top: 0px !important;'"
      :modalContentCustom="'padding-top: 0px !important;'"
    >
      <template v-slot:body>
        <div
          class="mdl-card-container div-container"
          style="width: 90%; margin-top: 30px"
        >
          <p class="text_modal">Puxa vida!</p>
          <p class="text_modal2">
            <br />Infelizmente, neste momento seu saldo resgatável é insuficiente para a
            contratação de empréstimo.
          </p>
        </div>
        <div class="mf__div-btn">
          <button class="mf__btn--voltar" @click="voltar()">Voltar</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
"use strict";

import Titulo from "../component/Titulo.vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { TheMask } from "vue-the-mask";
import Contratacao from "../component/Contratacao.vue";
import ContratacaoAberta from "../component/ContratacaoAberta.vue";
import FirebaseHelper from "../FirebaseHelper.js";
import Disclaimer from "../component/Disclaimer.vue";
import BancoSelect from "../component/BancoSelect.vue";
import Modal from "../component/Modal.vue";

const utils = require("../../functions/geral/utilsFunctions");
const Enum = require("../Enum");
const Bancos = require("../../public/estatico/listas/bancos");

export default {
  components: {
    Titulo,
    VueSlider,
    Contratacao,
    ContratacaoAberta,
    Disclaimer,
    vSelect,
    TheMask,
    BancoSelect,
    Modal,
  },
  data() {
    return {
      isLoad: true,
      modais: {
        bloqueioSaldoInsuficiente: false,
        bloqueioEmprestimoRecente: false,
        bcAgCc: false,
        bloqueioIdade: false,
      },
      participante: "",
      dados_bancarios: {
        banco: "",
        agencia: "",
        conta: "",
      },
      valid_dados_bancarios: {
        banco: true,
        agencia: true,
        conta: true,
      },
      bancos: Bancos.bancos,
      pagina: "",
      disclaimerTipo: "EMPRESTIMO",
      firebaseHelper: new FirebaseHelper(),
      pre_aprovado: 0,
      str_prev_aprovado: "",
      saldo_devedor: 0,
      str_saldo_devedor: "",
      taxa_adm: 0,
      fundo_risco: 0,
      detalheEmprestimo: {},
      taxa_mensal: 0,
      taxa_mensal_12: 0,
      indice_anterior: 0,
      formatter1: "{value} x",
      quantidade: 36,
      maximo: 0,
      str_maximo: "",
      str_bruto: "",
      str_taxa_mensal: "",
      minimo: 0,
      str_minimo: "",
      principal: 0,
      valorPrincipalTotal: 0,
      valido_maximo: true,
      valido_minimo: true,
      parcela: 0,
      simulador: true,
      emprestimoSolicitado: null,
      objRegrasModalidadeEmprestimo: new Object(),
      dadosEmprestimoSolicitado: new Object(),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      sliderOptions: {
        silent: true,
        dotSize: 14,
        height: 10,
        contained: false,
        data: null,
        min: 3,
        max: 60,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "always",
        tooltipPlacement: "top",
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        process: true,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
        processStyle: {
          backgroundColor: "#0C7BC6",
        },
        tooltipStyle: {
          backgroundColor: "#0C7BC6",
          "border-radius": "50%",
          "border-color": "#0C7BC6",
          display: "inline",
        },
        dotStyle: {
          backgroundColor: "#0C7BC6",
          "border-color": "#0C7BC6",
        },
        railStyle: {
          backgroundColor: "#d3cbcb",
          height: "8px",
          "border-radius": "4px",
        },
      },
      contratacao: {
        link_campanha: Enum.linkCampanha.EMPRESTIMO,
        msg_inicial: "",
        msg_vigencia: "",
        msg_novo_valor: "",
        valor_novo: "",
        valor_novo_Tela: "",
        valor_antigo: "",
        titulo_finalizacao: "",
        finalizacao_msg: "",
        finalizacao_msg_novo_valor: "",
        chave: "",
        uid: "",
        matricula: "",
        plano: "",
        label_button: "",
        resumo: [],
        aresCrm: {
          tipo: "emprestimo",
        },
      },
      uid: "",
      chave: "",
      camposPersonalizados: {
        cpf: "",
        chave: sessionStorage.chave,
        plano: sessionStorage.plano,
        valorprevidencia: "",
        premiomorte: "",
        premioinvalidez: "",
        coberturariscoinvalidez: "",
        coberturariscomorte: "",
        valoraporte: "",
      },
    };
  },
  watch: {
    emprestimoSolicitado(newValue, oldValue) {
      if (newValue !== oldValue && newValue === false) {
        this.camposPersonalizados.cpf = this.participante.data.cadastro.informacoes_pessoais.cpf;
        this.integrarCRM();
      }
    },
    principal(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        let valorLiquidoSolicitado = newValue;
        this.valorPrincipalTotal = valorLiquidoSolicitado + this.saldo_devedor;
        this.calcularEmprestimo2(
          valorLiquidoSolicitado,
          this.saldo_devedor,
          this.objRegrasModalidadeEmprestimo,
          this.quantidade
        );
      }
    },
    async quantidade(newValue, oldValue) {
      if (newValue !== oldValue) {
        let valorLiquidoSolicitado = Number(this.principal);
        await this.calcularEmprestimo2(
          valorLiquidoSolicitado,
          this.saldo_devedor,
          this.objRegrasModalidadeEmprestimo,
          this.quantidade
        );
      }
    },
  },
  async created() {
    this.participante = JSON.parse(sessionStorage.participante);
    this.uid = sessionStorage.getItem("uid");
    this.chave = sessionStorage.getItem("chave");
    await this.consultaDadosContratados();
  },
  methods: {
    voltar() {
      this.$router.back();
    },
    resetValid() {
      this.valid_dados_bancarios.banco = true;
      this.valid_dados_bancarios.agencia = true;
      this.valid_dados_bancarios.conta = true;
    },
    validarBcoAgCc() {
      this.resetValid();
      if (this.dados_bancarios.banco === "-" || this.dados_bancarios.banco.length < 4)
        this.valid_dados_bancarios.banco = false;
      if (this.dados_bancarios.agencia === "") this.valid_dados_bancarios.agencia = false;
      if (this.dados_bancarios.conta === "") this.valid_dados_bancarios.conta = false;
      var valid =
        this.valid_dados_bancarios.banco &&
        this.valid_dados_bancarios.agencia &&
        this.valid_dados_bancarios.conta;
      if (valid) {
        if (!this.dados_bancarios.conta.includes("-")) {
          this.dados_bancarios.conta = `${this.dados_bancarios.conta.substring(
            0,
            this.dados_bancarios.conta.length - 1
          )}-${this.dados_bancarios.conta.substring(
            this.dados_bancarios.conta.length - 1,
            this.dados_bancarios.conta.length
          )}`;
        }
        this.solicitarEmprestimo();
      } else return;
    },
    async consultaDadosContratados() {
      base_spinner.style.display = "flex";
      if (this.participante.contratacoes.emprestimo) {
        let dataHoje = utils.dateFormat(new Date(), false, false, false, false, false);
        let data = await this.firebaseHelper.getContratacao(
          this.chave,
          Enum.contratacao.EMPRESTIMO
        );
        if (data) {
          let contratacao = data[Object.keys(data)[0]];
          if (
            contratacao.status === Enum.statusContratacao.SOLICITADO ||
            contratacao.status === Enum.statusContratacao.EMANDAMENTO ||
            (contratacao.status === Enum.statusContratacao.EFETIVADA &&
              contratacao.iniVigencia > dataHoje)
          ) {
            this.processaDadosContratados(data);
          } else {
            data = null;
          }
        }
        if (!data) {
          this.simulador = true;
          this.emprestimoSolicitado = false;
          await this.consultaDados();
        }
      } else {
        this.simulador = true;
        this.emprestimoSolicitado = false;
        await this.consultaDados();
      }
      base_spinner.style.display = "none";
    },
    processaDadosContratados(data) {
      if (data) {
        this.simulador = false;
        this.emprestimoSolicitado = true;
        this.dadosEmprestimoSolicitado.tipo = Enum.contratacao.EMPRESTIMO;
        this.dadosEmprestimoSolicitado.titulo =
          "Consulta </br>contratação em </br>aberto";
        this.dadosEmprestimoSolicitado.dados = data;
        this.dadosEmprestimoSolicitado.chave = this.chave;
      }
    },
    async consultaDados() {
      let ret = await this.firebaseHelper.getDadosSimuladorEmprestimo(
        this.chave,
        this.uid
      );
      if (ret) {
        sessionStorage.dadosSimuladorEmprestimo = JSON.stringify(ret);
        this.montarDados(ret);
      } else {
        this.montarDados(JSON.parse(sessionStorage.dadosSimuladorEmprestimo));
      }
    },
    async montarDados(dataSimulador) {
      base_spinner.style.display = "flex";
      if (dataSimulador.bloqueio) {
        this.modais.bloqueioIdade = true;
      }
      if (dataSimulador.bloqueio_emprestimoRecente) {
        this.modais.bloqueioEmprestimoRecente = true;
      }
      if (dataSimulador.bloqueio_saldoInsuficiente) {
        this.modais.bloqueioSaldoInsuficiente = true;
      }
      this.saldo_devedor = dataSimulador.saldo_devedor;
      this.str_saldo_devedor = utils.valor_to_string_formatado(
        this.saldo_devedor,
        2,
        false,
        true
      );
      this.fundo_risco = dataSimulador.fundo_risco;
      this.indice_anterior = dataSimulador.indice_anterior;
      this.taxa_adm = dataSimulador.taxa_adm;
      this.taxa_mensal = dataSimulador.taxa_mensal;
      this.taxa_mensal_12 = dataSimulador.taxa_mensal_12;
      this.str_taxa_mensal = utils.valor_to_string_formatado(
        this.taxa_mensal,
        1,
        false,
        true
      );
      this.objRegrasModalidadeEmprestimo["taxaAdm"] = dataSimulador.taxa_adm;
      this.objRegrasModalidadeEmprestimo["taxaFundoRisco"] = dataSimulador.fundo_risco;
      this.objRegrasModalidadeEmprestimo["taxaJuros"] = dataSimulador.taxa_mensal;
      this.objRegrasModalidadeEmprestimo["taxaIof"] = dataSimulador.taxa_iof;
      this.objRegrasModalidadeEmprestimo["taxaIofAdicional"] =
        dataSimulador.taxa_iof_adicional;
      this.objRegrasModalidadeEmprestimo["diaVencimento"] = dataSimulador.dia_vencimento;
      this.objRegrasModalidadeEmprestimo["qtdDiasMaximoIof"] =
        dataSimulador.qtd_dias_maximo_iof;
      this.objRegrasModalidadeEmprestimo["qtdParcelasEntradaSimulador"] = this.quantidade;
      this.maximo = await this.firebaseHelper.calculaLimiteLiquidoEmprestimo(
        dataSimulador.pre_aprovado,
        dataSimulador.saldo_devedor,
        this.objRegrasModalidadeEmprestimo,
        new Date().toJSON().slice(0, 10)
      );
      dataSimulador.bloqueio_saldoInsuficiente = false;
      //se bloqueado por saldo insuficiente...
      if (dataSimulador.bloqueio_saldoInsuficiente || this.maximo <= 0) {
        this.modais.bloqueioSaldoInsuficiente = true;
        return;
      }
      this.str_bruto = utils.valor_to_string_formatado(
        dataSimulador.pre_aprovado,
        2,
        false,
        true
      );
      this.str_maximo = utils.valor_to_string_formatado(this.maximo, 2, false, true);
      this.pre_aprovado = dataSimulador.saldo_devedor + this.maximo;
      this.str_pre_aprovado = utils.valor_to_string_formatado(
        this.pre_aprovado,
        2,
        false,
        true
      );
      this.minimo = 500; //todo: criar config!!!!
      this.str_minimo = utils.valor_to_string_formatado(this.minimo, 2, false, true);
      this.principal = this.maximo / 2;
      this.contratacao.matricula = dataSimulador.matricula;
      this.contratacao.plano = dataSimulador.plano;
      this.valorPrincipalTotal = Number(this.principal) + this.saldo_devedor;
      base_spinner.style.display = "none";
    },
    async calcularEmprestimo2(
      valorLiquidoSolicitado,
      saldoDevedor,
      objRegrasModalidadeEmprestimo,
      qtdParcelas
    ) {
      base_spinner.style.display = "flex";
      if (valorLiquidoSolicitado + saldoDevedor > this.pre_aprovado) {
        this.valido_maximo = false;
        this.valido_minimo = true;
        this.parcela = "0";
      } else if (valorLiquidoSolicitado < this.minimo) {
        this.valido_minimo = false;
        this.valido_maximo = true;
        this.parcela = "0";
      } else {
        this.valido_maximo = true;
        this.valido_minimo = true;

        if (
          !objRegrasModalidadeEmprestimo.hasOwnProperty("taxaAdm") ||
          !objRegrasModalidadeEmprestimo.hasOwnProperty("taxaFundoRisco") ||
          !objRegrasModalidadeEmprestimo.hasOwnProperty("taxaJuros") ||
          !objRegrasModalidadeEmprestimo.hasOwnProperty("taxaIof") ||
          !objRegrasModalidadeEmprestimo.hasOwnProperty("taxaIofAdicional") ||
          !objRegrasModalidadeEmprestimo.hasOwnProperty("diaVencimento") ||
          !objRegrasModalidadeEmprestimo.hasOwnProperty("qtdDiasMaximoIof")
        ) {
          this.valido_maximo = false;
          this.valido_minimo = false;
          //return {sucesso: false, dadosEmprestimo: null, msg: 'Nem todos os parâmetros de regra de cálculo foram enviados.'}
        } else {
          let taxa = qtdParcelas <= 12 ? this.taxa_mensal_12 : this.taxa_mensal;
          this.objRegrasModalidadeEmprestimo["taxaJuros"] = taxa;
          this.str_taxa_mensal = utils.valor_to_string_formatado(taxa, 1, false, true);
          let dataLiberacao = new Date().toJSON().slice(0, 10);
          this.detalheEmprestimo = await this.firebaseHelper.calculaTotalBrutoEmprestimo(
            valorLiquidoSolicitado,
            saldoDevedor,
            qtdParcelas,
            dataLiberacao,
            objRegrasModalidadeEmprestimo
          );
          this.parcela = utils.valor_to_string_formatado(
            this.detalheEmprestimo.parcelas[1].total,
            2,
            false,
            true
          );
        }
      }
      base_spinner.style.display = "none";
    },
    async integrarCRM() {
      if (sessionStorage.isRP === "true") {
        return;
      }
      let infoAdicional = [
        {
          campo: "Ação",
          valor: `<u>Simulação de ${
            Enum.tiposSolicitacao[Enum.contratacao.EMPRESTIMO]
          }</u>`,
        },
        {
          campo: "Valor Pré-aprovado",
          valor: utils.valor_to_string_formatado(this.pre_aprovado, 2, true, true),
        },
        {
          campo: "Saldo Devedor Empréstimo",
          valor: utils.valor_to_string_formatado(this.saldo_devedor, 2, true, true),
        },
        {
          campo: "Chave",
          valor: this.chave,
        },
      ];

      let ret = await this.firebaseHelper.simuladorGeraLead(
        this.chave,
        this.uid,
        "emprestimo",
        Enum.tiposSolicitacao[Enum.contratacao.EMPRESTIMO],
        this.pre_aprovado,
        infoAdicional,
        this.contratacao.plano,
        null,
        this.camposPersonalizados
      );
      if (ret) {
        this.contratacao.aresCrm.negocioId = ret.negocioId;
      }
    },
    confirmarBcoAgCc() {
      this.saldoResgatavel = 0;
      if (
        ((this.participante.elegibilidade || {}).emprestimo || {}).saldoTotalResgatavel
      ) {
        this.saldoResgatavel = this.participante.elegibilidade.emprestimo.saldoTotalResgatavel;
      }
      this.dados_bancarios.banco = {
        value: this.participante.data.cadastro.dados_bancarios.idBanco,
        label: `${this.participante.data.cadastro.dados_bancarios.banco}-${this.participante.data.cadastro.dados_bancarios.descricaoBanco} `,
      };
      this.dados_bancarios.agencia = this.participante.data.cadastro.dados_bancarios.agencia;
      this.dados_bancarios.conta = this.participante.data.cadastro.dados_bancarios.conta;
      this.modais.bcAgCc = true;
    },
    atualizarCadastro() {
      this.participante.data.cadastro.dados_bancarios.banco = this.dados_bancarios.banco;
      this.participante.data.cadastro.dados_bancarios.agencia = this.dados_bancarios.agencia;
      this.participante.data.cadastro.dados_bancarios.conta = this.dados_bancarios.conta;
      sessionStorage.participante = JSON.stringify(this.participante);
      this.$root.$emit("atualizaDadosBancarios");
    },
    solicitarEmprestimo() {
      this.modais.bcAgCc = false;
      this.atualizarCadastro();
      //let vlrPrincipalTotal = parseFloat((this.valorPrincipalTotal).replace('R$','').split('.').join('')).toFixed(2)
      //reposiciona no topo para caso ter aberto o teclado no celular
      let pagina = document.querySelector(`#divFixedHeader`);
      pagina.scrollTop = 0;
      if (this.valido_maximo && this.valido_minimo) {
        this.contratacao.resumo = [];
        this.contratacao.titulo = "Solicitação </br>de empréstimo";
        this.contratacao.resumo.push(
          { nome: "DADOS BANCÁRIOS:", valor: "" },
          { nome: "Banco", valor: this.dados_bancarios.banco.label },
          { nome: "Agência", valor: this.dados_bancarios.agencia },
          { nome: "Conta", valor: this.dados_bancarios.conta },
          { nome: "&nbsp;", valor: "" },
          { nome: "DADOS DA SIMULAÇÃO:", valor: "" },
          { nome: "Quantidade de parcelas:", valor: this.quantidade },
          { nome: "Valor da parcela:", valor: `R$ ${this.parcela}` },
          {
            nome: "(a) Valor bruto calculado:",
            valor: `R$ ${utils.valor_to_string_formatado(
              this.detalheEmprestimo.valorTotalBruto,
              2,
              false,
              true
            )}`,
          },
          { nome: "&nbsp;", valor: "" },
          { nome: "DEDUÇÕES PROJETADAS:", valor: "" },
          {
            nome: "(b) Taxa Administrativa:",
            valor: `R$ ${utils.valor_to_string_formatado(
              this.detalheEmprestimo.custos.valorTaxaAdm,
              2,
              false,
              true
            )}`,
          },
          {
            nome: "(c) Fundo de risco:",
            valor: `R$ ${utils.valor_to_string_formatado(
              this.detalheEmprestimo.custos.valorTaxaFundoRisco,
              2,
              false,
              true
            )}`,
          },
          {
            nome: "(d) IOF:",
            valor: `R$ ${utils.valor_to_string_formatado(
              this.detalheEmprestimo.custos.valorTaxaIof +
                this.detalheEmprestimo.custos.valorTaxaIofAdicional,
              2,
              false,
              true
            )}`,
          }
        );
        if (this.saldo_devedor !== 0) {
          this.contratacao.resumo.push(
            {
              nome: "(e) Saldo empréstimo anterior:",
              valor: `R$ ${utils.valor_to_string_formatado(
                this.detalheEmprestimo.custos.valorSaldoRemanescente,
                2,
                false,
                true
              )}`,
            },
            { nome: "&nbsp;", valor: " " },
            {
              nome: "VALOR FINAL (a - b - c - d - e):",
              valor: `R$ ${utils.valor_to_string_formatado(
                this.detalheEmprestimo.valorLiquidoFinal -
                  this.detalheEmprestimo.custos.valorSaldoRemanescente,
                2,
                false,
                true
              )}`,
            }
          );
        } else {
          this.contratacao.resumo.push(
            { nome: "&nbsp;", valor: " " },
            {
              nome: "VALOR FINAL (a - b - c - d):",
              valor: `R$ ${utils.valor_to_string_formatado(
                this.detalheEmprestimo.valorLiquidoFinal,
                2,
                false,
                true
              )}`,
            }
          );
        }
        this.contratacao.msg_inicial = "";
        this.contratacao.msg_vigencia = "";
        this.contratacao.msg_novo_valor = "";
        this.contratacao.observacao =
          "Os dados acima apresentados referem-se apenas a uma simulação. Os valores a serem concedidos podem sofrer variações de acordo com a data efetiva da concessão e características do seu plano de previdência.";
        this.contratacao.observacao2 =
          "Interessado? Clique abaixo em Solicitar que enviaremos para o seu e-mail o contrato de empréstimo com os respectivos valores efetivos ou eventual nova proposta para adequação da linha de empréstimo conforme seu plano de previdência.";
        this.contratacao.valor_novo = this.detalheEmprestimo.valorTotalBruto;
        this.contratacao.valor_novo_Tela = utils.valor_to_string_formatado(
          this.detalheEmprestimo.valorTotalBruto,
          2,
          false,
          true
        );
        this.contratacao.valor_antigo = this.saldo_devedor; //parseFloat(this.saldo_devedor.toString().replace(/\./g,''))
        this.contratacao.titulo_finalizacao =
          "Solicitação </br> de empréstimo </br>encaminhada";
        this.contratacao.finalizacao_msg =
          "Legal! A partir de agora mantenha-se atento, pois em breve enviaremos um e-mail com o seu contrato para assinatura digital.";
        this.contratacao.finalizacao_msg2 =
          "Ao receber, leia-o atentamente e, estando de acordo, efetue a assinatura seguindo os passos da nossa ferramenta.";
        this.contratacao.finalizacao_msg3 =
          "Importante: o e-mail será enviado por sign@d4sign.com.br. Lembre-se sempre de verificar também em sua caixa de Spam ou Lixo Eletrônico.";
        //this.contratacao.finalizacao_msg_novo_valor = 'Valor bruto simulado de R$ '
        this.contratacao.chave = this.chave;
        this.contratacao.uid = this.uid;
        this.contratacao.label_button = "Solicitar";
        this.contratacao.tipo = Enum.contratacao.EMPRESTIMO;
        this.contratacao.enviarEmail = true;
        this.contratacao.aresCrm.tipo = "emprestimo";
        this.contratacao["detalhes"] = {
          saldoEmprestimo: this.saldo_devedor,
          vlrSolicitadoEmprestimo: this.detalheEmprestimo.valorTotalBruto,
          valorParcela: 0,
          reservaResgatavelParticipante: this.saldoResgatavel,
          contratoEmprestimo: {
            saldoEmprestimo: this.saldo_devedor,
            vlrSolicitadoEmprestimo: this.detalheEmprestimo.valorTotalBruto,
            qtdParcelas: this.quantidade,
            percentualPago: "",
            valorParcela: Number(this.parcela.replace('.','').replace(',','.'))
          }
        };
        this.simulador = false;
      }
    },
    fecharContratacao(value) {
      this.simulador = value;
    },
    closeModal() {
      this.modais.bcAgCc = false;
    },
    bancoSelected(banco) {
      this.dados_bancarios.banco = {
        value: banco.id,
        label: `${banco.codigo}-${banco.descricao}`,
      };
    },
  },
};
</script>

<style>
.btn-modal {
  margin: auto;
  height: 55px;
}

.div-formulario {
  width: -webkit-fill-available;
}

p.error-valid {
  font-size: 9px;
  color: red;
  text-align: center;
}

.span-label {
  font-size: 10px;
  color: gray;
  padding-left: 15px;
  line-height: 10px;
}

.v-select {
  margin-top: 10px;
}

.input_numeric {
  height: 40px;
}

p.text_modal {
  line-height: 18px;
  text-align: left;
  font-size: 16px;
  font-family: "MaisFuturo-Medium";
  letter-spacing: 0px;
  color: #131721;
  opacity: 1;
  margin-bottom: 2px !important;
}

p.text_modal2 {
  line-height: 18px;
  text-align: left;
  font-size: 16px;
  font-family: "MaisFuturo-Regular";
  letter-spacing: 0px;
  color: #131721;
  opacity: 1;
  margin-bottom: 2px !important;
}
</style>
